<div>
    <div class="alert alert-info" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
        <strong>Info!</strong> You can drag this dialog by this alert.
    </div>

    <div class="withSpace">
        <button mat-raised-button color="primary" (click)="onNoClick()">Close</button>
        <span> &nbsp;</span>
        <button mat-raised-button color="primary" [mat-dialog-close]="formComponent" [disabled]="formComponent.id.length==0">Save</button>
    </div>

    <div>
        <mat-form-field class="withSpace" appearance="outline">
            <mat-label>Id</mat-label>
            <input matInput [(ngModel)]="formComponent.id" required="true">
        </mat-form-field>
        <mat-form-field class="withSpace" appearance="outline">
            <mat-label>Label</mat-label>
            <input matInput [(ngModel)]="formComponent.label">
        </mat-form-field>
        <div class="row">
            <predefined-validators class="col-6" [formComponent]="formComponent" *ngIf="allowsValidators()"></predefined-validators>
            <predefined-options class="col-6" [formComponent]="formComponent"></predefined-options>
        </div>
    </div>
</div>
